import { useReduxState } from 'hooks';
import { Button } from 'components/common';
import { StatCount } from 'components/common/stats';

import { useBoxContext, useBoxDispatch } from './BoxContext';

import type { StatCategory } from 'components/common/stats/StatCount';

interface Props {
  category?: StatCategory;
  numberOfItems: number;
  title: string;
}

const BoxTitleWithSelectedItems = ({
  category = 'default',
  numberOfItems,
  title
}: Props) => {
  const { selectedItems } = useBoxContext();

  const dispatch = useBoxDispatch();

  const { messages, theme } = useReduxState();

  const selectedParticipants = Object.keys(selectedItems)?.length;

  return (
    <div className="wrapper">
      <div className="title">
        <div className="count">
          <StatCount category={category} isLarge={true} value={numberOfItems} />
        </div>

        {title}
      </div>

      {selectedParticipants > 0 ? (
        <>
          <div className="title selected">
            <div className="count">
              <StatCount isLarge={true} value={selectedParticipants} />
            </div>

            {messages.usersFiltersUsersSelected}
          </div>

          <Button
            category="lighter"
            icon="times"
            isRounded={true}
            onClick={() => dispatch({ type: 'resetSelection' })}
            size="small"
            style={{ marginLeft: 7, padding: '4px 9px 5px 7px' }}
            text={messages.commonClear}
          />
        </>
      ) : null}

      <style jsx>{`
        .wrapper {
          align-items: center;
          display: flex;
          gap: 5px;
        }
        .count {
          padding-bottom: 1px;
        }
        .title {
          align-items: center;
          display: flex;
          font-size: 1.6rem;
          font-weight: 700;
          gap: 5px;
          padding: 1px 0;
        }
        .selected {
          border: 2px solid ${theme.lightGreyDark};
          border-width: 0 0 0 2px;
          color: ${theme.textColorLighter};
          font-weight: 600;
          margin-left: 7px;
          padding: 0 0 0 12px;
        }
      `}</style>
    </div>
  );
};

export default BoxTitleWithSelectedItems;
